export const ALERT_TYPES = {
  DANGER: 'danger',
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
};

export const MESSAGE_TYPES = {
  DEBUG: 'debug',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
};
